import React from 'react';
import { SupplierData, SaleData } from '../../../types';

const formatCNPJ = (cnpj: string): string => {
    if (!cnpj) return '';
    const cleaned = cnpj.replace(/\D/g, '');
    if (cleaned.length !== 14) return cnpj;
    return `${cleaned.slice(0, 2)}.${cleaned.slice(2, 5)}.${cleaned.slice(5, 8)}/${cleaned.slice(8, 12)}-${cleaned.slice(12)}`;
};

interface HeaderProps {
    supplierData: SupplierData;
    saleData: SaleData;
    currentStep: number;
    getFormattedCard: () => string;
    getPricePerLiter?: () => string;
    isLoadingVehicle?: boolean;
}

export const Header: React.FC<HeaderProps> = ({ supplierData, saleData, currentStep, getFormattedCard, getPricePerLiter, isLoadingVehicle }) => {
    return (
        <div className="terminal-header">
            <img src="/images/banner.jpg" alt="Banner" className="banner" />
            <div className="supplier-info">
                {(supplierData.name || supplierData.cnpj) && (
                    <div className="supplier-details">
                        {supplierData.name && (
                            <div className="supplier-field supplier-main">
                                <label>Nome do Fornecedor:</label>
                                <span className="supplier-name">{supplierData.name}</span>
                            </div>
                        )}
                        {supplierData.cnpj && (
                            <div className="supplier-field supplier-cnpj-field">
                                <label>CNPJ:</label>
                                <span className="supplier-cnpj">{formatCNPJ(supplierData.cnpj)}</span>
                            </div>
                        )}
                    </div>
                )}

                {currentStep >= 1 && (saleData.clientName || saleData.showFirstData || isLoadingVehicle) && (
                    <div className="vehicle-client-details">
                        {isLoadingVehicle ? (
                            <div className="client-section">
                                <div className="supplier-field client-field-inline">
                                    <label>Cliente:</label>
                                    <span className="client-name loading-indicator">
                                        <span className="loading-spinner-small"></span>
                                        Buscando...
                                    </span>
                                </div>
                            </div>
                        ) : saleData.clientName && saleData.clientName !== 'Cliente não identificado' && (
                            <div className="client-section">
                                <div className="supplier-field client-field-inline">
                                    <label>Cliente:</label>
                                    <span className="client-name">{saleData.clientName}</span>
                                </div>
                            </div>
                        )}
                        {saleData.showFirstData && (
                            <div className="vehicle-section">
                                <div className="supplier-field client-field-inline">
                                    <label>Placa do Veículo:</label>
                                    <span className="vehicle-plate">
                                        {saleData.vehiclePlate || getFormattedCard()}
                                    </span>
                                </div>
                                <div className="supplier-field client-field-inline">
                                    <label>Cartão do Veículo:</label>
                                    <span className="vehicle-plate">
                                        {getFormattedCard()}
                                    </span>
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {currentStep === 3 && (
                    <div className="sale-complete-details">
                        <div className="sale-details-row">
                            <div className="supplier-field client-field-inline">
                                <label>Motorista:</label>
                                <span>{saleData.driverName}</span>
                            </div>
                            <div className="supplier-field client-field-inline">
                                <label>Hodômetro:</label>
                                <span>{saleData.odometer} km</span>
                            </div>
                            <div className="supplier-field client-field-inline">
                                <label>Produto:</label>
                                <span>{saleData.product}</span>
                            </div>
                        </div>
                        <div className="sale-details-row">
                            <div className="supplier-field client-field-inline">
                                <label>Quantidade:</label>
                                <span>{saleData.liters} L</span>
                            </div>
                            <div className="supplier-field client-field-inline">
                                <label>Valor Total:</label>
                                <span>R$ {saleData.totalValue}</span>
                            </div>
                            <div className="supplier-field client-field-inline">
                                <label>Valor por Litro:</label>
                                <span>R$ {getPricePerLiter?.() || '0.00'}/L</span>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
